export default {
    baseUrl: {
        dev: "/api",
        pro: "/api"
    },
    activityBaseUrl: {
        // dev: "/api",
        // pro: "/api"
        dev: "/activityapi",
        pro: "/activityapi"
    },
    CDN: "https://custom-center.oss-cn-hangzhou.aliyuncs.com/customerCenter"
}